import FancyResult from "./FancyResult";
export default FancyResult;